import { useState, useEffect } from 'react'
import { useDebouncedCallback } from '@workspace/frontend-kit'
import { UseDataSearchProps } from './_props'

const useDataSearch = ({ searchText, value, searchDataFunction }: UseDataSearchProps) => {
    const [patients, setPatients] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchPatients = async (term: string) => {
        if (!term.length) {
            setPatients([])
            setLoading(false)
        } else if (!value && term.length >= 1) {
            setLoading(true)
            const result = await searchDataFunction(term)
            setPatients(result ?? [])
            setLoading(false)
        }
    }

    const debouncedFetchPatients = useDebouncedCallback(fetchPatients, 300)

    useEffect(() => {
        debouncedFetchPatients(searchText)
    }, [searchText, debouncedFetchPatients])

    return {
        patients,
        loading,
    }
}

export default useDataSearch
